/**
 * Created by Administrator on 2017/10/27.
 */
import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";
declare var alertify:any;
@Component({
  templateUrl:'./systemSetting.html'
})

export class SystemSetting implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];

  private imagePath:string='';

  ngOnInit(): void {
    this.getData();

  }



  private getData(){
    this.http.getData(API.systemSetting).then(res=>{
      this.data=res.data;
      if(typeof this.data.startTime=='object'){
        this.data.startTime='';
      }
      if(typeof this.data.endTime=='object'){
        this.data.endTime='';
      }

    });
  }

  private edit(){
    this.router.navigate(['index/systemSetting/edit']);
  }





}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/systemSetting/systemSetting.component.ts